import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BillsAndReportsApi = createApi({
  reducerPath: "BillsAndReportsApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BillsAndReportsApi"],
  endpoints: (build) => ({
    getAllBills: build.query({
      query: ({ id }) => ({
        url: `/all-bill-details?id=${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BillsAndReportsApi"],
    }),

    getReports: build.query({
      query: ({ billId, orgId, patientId }) => ({
        url: `/all-reports?billId=${billId}&orgId=${orgId}&patientId=${patientId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BillsAndReportsApi"],
    }),
    getBill: build.query({
      query: ({ billId, orgId }) => ({
        url: `/get-bill?billId=${billId}&orgId=${orgId}`,
        method: "GET",
        responseHandler: (response) => response.arrayBuffer(),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),

      providesTags: ["BillsAndReportsApi"],
    }),
    getAppointMentId: build.query({
      query: ({ billId }) => ({
        url: `/bill?billId=${billId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),

      providesTags: ["BillsAndReportsApi"],
    }),
    rescheduleAppointment: build.mutation({
      query: ({ data }) => ({
        url: `/crelio/reschedule-appointment`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BillsAndReportsApi"],
    }),
    rescheduleHomeCollection: build.mutation({
      query: (data) => ({
        url: "/crelio/reschedule-home-collection",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BillsAndReportsApi"],
    }),

    dismissAppointment: build.mutation({
      query: (data) => ({
        url: "/crelio/dismiss-appointment",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BillsAndReportsApi"],
    }),
    createRazorPayOrder: build.mutation({
      query: (data) => ({
        url: "/razorpay/create-order",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BillsAndReportsApi"],
    }),
  }),
});

export const {
  useGetAllBillsQuery,
  useGetReportsQuery,
  useGetBillQuery,
  useGetAppointMentIdQuery,
  useDismissAppointmentMutation,
  useRescheduleAppointmentMutation,
  useRescheduleHomeCollectionMutation,
  useCreateRazorPayOrderMutation,
} = BillsAndReportsApi;
